import { Page } from "components/page/page.component";
import { View } from "components/view/view.component";
import { Text } from "components/text/text.component";
import style from './dashboard.restaurant.santander.page.module.css'
import { useGetSantanderRestaurantsDashboardDataApi } from "api/dashboard.api";
import { useEffect, useState } from "react";
import { toDateMonthYearHourMinuteString, toDateMonthYearString, toHourMinuteString } from "utils/date.util";
import { MAX_SANTANDER_RESTAURANT_CAPACITY } from "data/santander.data";
import { RestaurantCardComponent } from "components/restaurantCard/restaurantCard.component";
import { Icon } from "components/icon/icon.component";
import { OccupationCountGraphicComponent } from "components/graphic/santander/occupation.count.graphic.component";

export function DashboardPainelRestaurantSantanderPage() {

    const {data, get} = useGetSantanderRestaurantsDashboardDataApi()
    const [scale, setScale] = useState(2)
    const [showSlider, setShowSlider] = useState(true)
    // const marmitaScale = scale * (2 / 3)
    const cardHeight = 387 // Altura aproximada do RestaurantCard com showPie=true

    const filteredGraphicIndicators = data?.graphicIndicators.labels.reduce<{
        labels: Date[],
        restauranteValues: (number | undefined)[],
        salaDeMarmitasValues: (number | undefined)[]
    }>((acc, label, index) => {
        const startDate = new Date(data.graphicIndicators.labels[0])
        startDate.setHours(11, 0, 0, 0) // Define o início às 11:00
        const endDate = new Date(data.graphicIndicators.labels[0])
        endDate.setHours(16, 0, 0, 0) // Define o fim às 16:00

        const currentDate = new Date(label)

        if (currentDate >= startDate && currentDate <= endDate) {
            acc.labels.push(label)
            acc.restauranteValues.push(data.graphicIndicators.restauranteValues[index])
            acc.salaDeMarmitasValues.push(data.graphicIndicators.salaDeMarmitasValues[index])
        }

        return acc
    }, { labels: [], restauranteValues: [], salaDeMarmitasValues: [] })

    useEffect(()=>{
        // Executa imediatamente
        get()
        
        // Configura para executar a cada minuto (60000ms)
        const interval = setInterval(() => {
            get()
        }, 60000);
        
        // Limpa o interval quando o componente for desmontado
        return () => clearInterval(interval);
    // eslint-disable-next-line
    },[])

    return <Page menu header title='Ocupação do Restaurante'>
        <View className={style.RestaurantDashboardContainer} >
            {/* {loading ? <><PieCard loading /> <PieCard loading /> </> :  */
            <>
                <View className={style.CardsContainer}>
                    <View style={{width: '100%', textAlign: 'center', marginBottom: '8px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '8px', position: 'relative'}}>
                        <Text type='h3'>{`Última atualização: ${data?.date ? toDateMonthYearHourMinuteString(data.date) : ''}`}</Text>
                        <button 
                            onClick={() => setShowSlider(!showSlider)}
                            title={showSlider ? 'Ocultar Controle de Tamanho' : 'Mostrar Controle de Tamanho'}
                            style={{
                                padding: '4px',
                                cursor: 'pointer',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: 'transparent',
                                color: 'var(--text-color)',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: 0.5,
                                transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                            onMouseLeave={(e) => e.currentTarget.style.opacity = '0.5'}
                        >
                            <Icon fontSize='small'>{showSlider ? 'visibility_off' : 'settings'}</Icon>
                        </button>
                    </View>
                    {showSlider && <View style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', marginBottom: '16px'}}>
                        <View style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <Text type='h6'>Tamanho dos Cards:</Text>
                            <input 
                                type="range" 
                                min="1" 
                                max="6" 
                                step="0.1" 
                                value={scale} 
                                onChange={(e) => setScale(parseFloat(e.target.value))}
                                style={{width: '200px', cursor: 'pointer', accentColor: 'var(--primary-color)'}}
                            />
                            <Text type='h6'>{`${Math.round(scale * 100)}%`}</Text>
                        </View>
                    </View>}
                    <View style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px', justifyContent: 'center', alignItems: 'flex-start'}}>
                        <View style={{transform: `scale(${scale})`, transformOrigin: 'top left', marginTop: '0', marginBottom: `${((scale - 1) * cardHeight) - ((scale - 1) * 100)}px`, marginRight: `${(scale - 1) * 225}px`}}>
                            <RestaurantCardComponent 
                                title="Restaurante" 
                                value={data?.cards.find(card => card.id === 'restaurante')?.value} 
                                total={MAX_SANTANDER_RESTAURANT_CAPACITY} 
                                showPie={true} 
                            />
                        </View>
                        {/* <RestaurantCardComponent title="Restaurante" value={537} total={MAX_SANTANDER_RESTAURANT_CAPACITY} /> */}
                        {/* <PieCard value={data?.cards.find(card => card.id === 'restaurante')?.value} max={MAX_SANTANDER_RESTAURANT_CAPACITY} /> */}
                        {/* <View style={{transform: `scale(${marmitaScale})`, transformOrigin: 'top left', marginTop: '0', marginBottom: `${(marmitaScale - 1) * 250}px`, marginRight: `${(marmitaScale - 1) * 150}px`}}>
                            <PieCard title="Sala de Marmitas" value={data?.cards.find(card => card.id === 'sala-de-marmitas')?.value} max={data?.cards.find(card => card.id === 'sala-de-marmitas')?.value} />
                        </View> */}
                    </View>
                </View>
                <View style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px', justifyContent: 'center', alignItems: 'center', marginTop: '16px'}}>
                    <OccupationCountGraphicComponent 
                        title={`${data?.date ? `${toDateMonthYearString(data?.date)} - ` : ''}Ocupação no almoço`} 
                        showLegends 
                        labels={filteredGraphicIndicators?.labels.map(_ => toHourMinuteString(_)) ?? []} 
                        restauranteValues={filteredGraphicIndicators?.restauranteValues ?? []} 
                        salaDeMarmitasValues={filteredGraphicIndicators?.salaDeMarmitasValues ?? []} 
                        showReferenceLines = {false}
                        showReferenceLinesLegends = {false}
                        referenceValue={MAX_SANTANDER_RESTAURANT_CAPACITY}
                        hideSalaDeMarmitas
                        max={MAX_SANTANDER_RESTAURANT_CAPACITY}
                        showMaxReferenceLine
                    />
                </View>
            </>}
        </View>
    </Page>
}